import { I18n } from '@ngx-translate/i18n-polyfill';
import { MotiusAnulacioFilterService } from './../../services/motius-anulacio-filter-service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { MotiusAnulacio } from '../../models/motius-anulacio.model';
import { MotiusAnulacioFilter } from '../../models/motius-anulacio-filter';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { MotiusAnulacioService } from '../../services/motius-anulacio.service';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';

@Component({
  selector: 'app-motius-anulacio-table',
  templateUrl: './motius-anulacio-table.component.html',
  styleUrls: ['./motius-anulacio-table.component.scss']
})
export class MotiusAnulacioTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: MotiusAnulacio[];
  dataSource: CustomDataSource<MotiusAnulacio, MotiusAnulacioFilter>;
  filter: MotiusAnulacioFilter = new MotiusAnulacioFilter('descripcio', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: MotiusAnulacioFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['id', 'descripcio'];

  constructor(
    private motiusAnulacioService: MotiusAnulacioService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<MotiusAnulacio, MotiusAnulacioFilter>(this.paginator, new MotiusAnulacioFilterService(), 'urlGetMotiusAnulacio', 'urlGetCountMotiusAnulacio');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('motius-anulacio-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('motius-anulacio-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.motiusAnulacioService, filter, this.i18n('MotiusAnulacio'), this.sort.direction, this.sort.active)
    });
  }

}
